<template>
  <div
    v-show="$store.state.displayMap"
  >
    <mq-layout
      mq="mobile"
      class="back-to-search"
    >
      <v-btn
        v-if="$store.state.detailOrigin === 'search'"
        class="control"
        small
        fab
        @click="$store.commit('showSearchMenu');"
      >
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
    </mq-layout>
    <div
      class="mapcontrols"
      :style="$mq | mq({
        mobile: 'top: 0.5em;right: 0.5em;align-items: flex-end;flex-direction: column;',
        tablet: 'bottom: 1.5em;right: 0.5em;align-items: flex-end;flex-direction: column-reverse;',
        desktop: 'bottom: 1.5em;right: 0.5em;align-items: flex-end;flex-direction: row-reverse;',
      })"
    >
      <attributions />
      <!--
        ** GEOLOCATION **
      -->
      <v-btn
        v-if="hideGeolocation == null || hideGeolocation == false"
        class="control"
        small
        fab
        @click="getMapboxLoc"
      >
        <v-icon
          :color="locIconColor"
        >
          {{ locIcon }} mdi-24px
        </v-icon>
      </v-btn>
      <!--
        ** RETURN TO START **
      -->
      <v-btn
        v-if="!(showHomeButton == false)"
        class="control"
        small
        fab
        @click="emit('return-to-start')"
      >
        <v-icon>mdi-home mdi-24px</v-icon>
      </v-btn>
      <!--
        ** 3D **
      -->
      <v-btn
        v-if="initShow3dOption"
        id="3d-option"
        class="control"
        small
        fab
        @click="emit('tilt-map')"
      >
        <v-icon>mdi-rotate-orbit mdi-24px</v-icon>
      </v-btn>
      <!--
        ** NORTH ARROW **
      -->
      <mq-layout
        v-if="initNorth"
        mq="mobile"
      >
        <v-btn
          id="compass"
          class="control"
          small
          fab
          @click="emit('orientation-reset')"
        >
          <v-img
            :style="{transform: mapRotation}"
            :src="northArrowSvg"
            contain
            aspect-ratio="1"
          />
        </v-btn>
      </mq-layout>
      <print-map />
      <bookmarks />
      <floor-select />
      <legend-control />
    </div>
    <div
      class="ol-controls"
      :style="$mq | mq({
        tablet: `bottom: ${btnAlignment}em;right: 0.5em;align-items: flex-end;`,
        desktop: 'bottom: 6em;right: 0.5em;align-items: flex-end;',
      })"
    >
      <mq-layout
        v-if="initNorth"
        mq="tablet+"
      >
        <v-btn
          id="compass"
          class="control"
          small
          fab
          @click="emit('orientation-reset')"
        >
          <v-img
            :style="{transform: mapRotation}"
            :src="northArrowSvg"
            contain
            aspect-ratio="1"
          />
        </v-btn>
      </mq-layout>
      <mq-layout
        mq="tablet+"
      >
        <v-btn
          id="zoom-in"
          class="control"
          small
          fab
          @click="emit('zoom-in')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          id="zoom-out"
          class="control"
          small
          fab
          @click="emit('zoom-out')"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import {
  EventBus,
} from '../../event-bus';
import Attributions from './Attributions.vue';
import FloorSelect from './FloorSelect.vue';
import LegendControl from './LegendControl.vue';
import Bookmarks from './Bookmarks.vue';
import PrintMap from './PrintMap.vue';

export default {
  name: 'MapControls',
  components: {
    FloorSelect,
    Bookmarks,
    PrintMap,
    Attributions,
    LegendControl,
  },
  props: {},
  data() {
    return {
      northArrowSvg: './icons/northArrow.svg',
      initShow3dOption: this.$appConfig.show3dOption,
      showHomeButton: this.$appConfig.showHomeButton,
      initNorth: this.$appConfig.showNorth,
      hideGeolocation: this.$appConfig.hideGeolocation,
      locationState: 0,
      locIconColor: 'black',
      locIcon: 'mdi-map-marker-outline',
      mapRotation: 'rotate(0rad)',
      btnAlignment: 13,
    };
  },
  computed: {
  },
  mounted() {
    const me = this;
    if (me.$appConfig.floorSelector) {
      this.btnAlignment += 3;
    }
    if (me.$appConfig.show3dOption) {
      this.btnAlignment += 3;
    }
    if (me.$appConfig.showPrintOption) {
      this.btnAlignment += 3;
    }
    if (me.$appConfig.bookmarkSelector) {
      this.btnAlignment += 3;
    }
    if (me.$appConfig.showLegend) {
      this.btnAlignment += 4;
    }

    // rotates compass to north according to current map rotation
    EventBus.$on('rotation', (deg) => {
      me.mapRotation = `rotate(-${deg + 360}deg)`; // change direction
    });
    EventBus.$on('map-movement', () => {
      this.locIcon = 'mdi-map-marker-outline';
      this.locIconColor = 'black';
    });
  },
  methods: {
    nextState() {
      this.locationState += 1;
      switch (this.locationState % 2/* 3 */) {
        // doesn't do anything
        case 0: this.noGeolocation();
          break;
        // catches geolocation once and zooms to that position
        case 1: this.getGeolocation();
          break;
        // watches over location and follows it
        case 2: this.watchGeolocation();
          break;
        default:
          // eslint-disable-next-line no-console
          console.warn('Error with Geolocation Switcher in MapControls.vue.');
          break;
      }
      /*
      if (this.locationState === 1) {
        const timeout = setTimeout(() => {
          this.locationState = 0;
          this.noGeolocation();
          // eslint-disable-next-line
          console.log('no geoloc');
        }, 10000);
        // FEATURE do not turn off on time but on map drag
      } */
    },
    getMapboxLoc() {
      this.locIcon = 'mdi-map-marker';
      this.locIconColor = 'blue darken-2';
      // send signal to Mapbox
      this.emit('get-geolocation');
    },
    noGeolocation() {
      this.locIcon = 'mdi-map-marker-outline';
      this.locIconColor = 'black';
      // EventBus.$emit('no-geolocation');
      this.emit('get-geolocation');
      // FEATURE stop watching location
    },
    getGeolocation() {
      this.locIcon = 'mdi-map-marker';
      this.locIconColor = 'blue darken-2';
      // send signal to Mapbox
      this.emit('get-geolocation');
    },
    watchGeolocation() {
      this.locIcon = 'mdi-map-marker';
      EventBus.$emit('watch-geolocation');
    },
    emit(string) {
      EventBus.$emit(string);
    },
  },
};
</script>

<style scoped>
.back-to-search {
  position: fixed;
  top: 0.5em;
  left: 0.5em;
  width: auto;
  z-index: 1;
}
.mapcontrols {
  position: fixed;
  width: auto;
  z-index: 1;
  display: flex;
}
.control {
  border-radius:10px;
  margin: 0.25em;
}
.ol-controls {
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 1;
  width: 3em;
}
#compass {
  margin: 0.25em 0.25em 1.5em;
}
#zoom-in {
  border-radius: 10px 10px 0 0;
  margin: 0.25em 0.25em 1px;
}
#zoom-out {
  border-radius: 0 0 10px 10px;
  margin: 1px 0.25em 0.25em;
}

.v-btn {
  width: 3em;
}
</style>
